export const SHOW_STRIPE_PAYMENT_MODAL = 'SHOW_STRIPE_PAYMENT_MODAL'
export const SHOW_LOGIN_MODAL = 'SHOW_LOGIN_MODAL'
export const HIDE_MODAL = 'HIDE_MODAL'
